import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, {
    "no-sidebar": true,
    "no-search": true
  }, {
    "header-left": _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "Maintenance", -1)
    ]))]),
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "white-box" }, " We are currently working to make Puffin more secure. ", -1))
    ]),
    _: 1
  }))
}